import React from 'react'
import PropTypes from 'prop-types'
import style from './style.scss'//NOSONAR

const Allergens = (props) => {
    const { product } = props;

    if (!((product && product.Trazas) || (product && product.Alérgenos) && product && product.Ingredientes)) {
        return ""
    }
    let lastTraces= null;
    let lastAllergens = null;
    let traces = product.Trazas && product.Trazas.length ? product.Trazas[0] : "";
    let allergens = product.Alérgenos && product.Alérgenos.length ? product.Alérgenos[0] : "";
    let arrayTraces = product.Trazas;
    let arrayAllergens = product.Ingredientes

    if (arrayTraces?.length > 1) {
        lastTraces = arrayTraces.pop();
        traces = arrayTraces.join(", ") + " y " + lastTraces;
    }

    if (arrayAllergens?.length > 1) {
        lastAllergens = arrayAllergens.pop();
        allergens = arrayAllergens.join(", ") + " y " + lastAllergens;
    }

    return (
        <div className="allergens-container">
            <span className="allergens-title">Puede contener</span>
            <span className="allergens-value">{traces && <><strong> Trazas </strong> de {traces.toLowerCase()}</>}
                {allergens && <><strong>{(traces) ? '. ' + 'Alérgenos' : 'Alérgenos' }</strong> de {allergens.toLowerCase()}</>}.</span>
        </div>
    )
}

Allergens.propTypes = {
    product: PropTypes.object,
}

export default Allergens;
